import { useMemo } from "react";
import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { createIdMap, formatName } from "@tellescope/utils";
import { useTranslation } from "react-i18next";
import type { EnduserRelationship } from "@tellescope/types-models";
import { BadgeListCell } from "./BadgeListCell";

export interface RelationshipsFieldCellProps {
  relationships: EnduserRelationship[];
}

export const RelationshipsFieldCell = ({ relationships }: RelationshipsFieldCellProps) => {
  const { t } = useTranslation("contacts");

  const relatedIds = useMemo(() => Array.from(new Set(relationships.map(({ id }) => id))), [relationships]);

  const endusersQuery = useTellescopeQuery({
    model: "endusers",
    method: "getByIds",
    request: { ids: relatedIds },
    enabled: relatedIds.length > 0,
    select: (data) => createIdMap(data.matches),
  });

  const items = useMemo(
    () =>
      relationships.map(({ id, type }) => {
        const related = endusersQuery.data?.[id];
        const name = related ? formatName(related) || related.email || t("Unknown patient") : t("Unknown patient");
        return { key: `${type}-${id}`, label: `${type}: ${name}` };
      }),
    [relationships, endusersQuery.data, t]
  );

  return <BadgeListCell items={items} emptyLabel={t("No relationships")} />;
};
